var map = {
	"./escapeStalingradZ_NewGameBox.png": 5353,
	"./hoplomachusV_NewGameBox.png": 7926,
	"./isofarianGuard_NewGameBox.png": 2258,
	"./lludwiksLabyrinth_NewGameBox.png": 4731,
	"./mhw_NewGameBox.png": 1587,
	"./novaAetasRenaissance_NewGameBox.png": 9447,
	"./oathsworn_NewGameBox.png": 1582,
	"./phantomEpoch_NewGameBox.png": 8507,
	"./primalAwakening_NewGameBox.png": 483,
	"./soulRaiders_NewGameBox.png": 6204,
	"./stonesaga_NewGameBox.png": 4644
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1538;